import { render, staticRenderFns } from "./NumberConfigView.vue?vue&type=template&id=7b204ef2"
import script from "./NumberConfigView.vue?vue&type=script&lang=js"
export * from "./NumberConfigView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports